import { Main } from 'designsystem/components/4-habitats/Main';

export const MainFeature: React.FC<{
	children: Content.PageContent['children'];
}> = ({ children }) => {
	return <Main>{children}</Main>;
};
